import React, { Component } from "react";
import { Modal, Row, Col } from "antd";
import "./Modal.css";
import RelContasPagRec1 from '../imagens/RelContasPagRec/ContasPagRec1.png';
import RelContasPagRec2 from '../imagens/RelContasPagRec/ContasPagRec2.png';
import RelContasPagRec3 from '../imagens/RelContasPagRec/ContasPagRec3.png';
import RelContasPagRec4 from '../imagens/RelContasPagRec/ContasPagRec4.png';
import RelContasPagRec5 from '../imagens/RelContasPagRec/ContasPagRec5.png';
import RelContasPagRec6 from '../imagens/RelContasPagRec/ContasPagRec6.png';
import RelContasPagRec7 from '../imagens/RelContasPagRec/ContasPagRec7.png';
import RelContasPagRec8 from '../imagens/RelContasPagRec/ContasPagRec8.png';
import RelContasPagRec9 from '../imagens/RelContasPagRec/ContasPagRec9.png';

export default class RelContasPagRec extends Component {

    render() {

        const { isOpen, onClose } = this.props;

        return (
            <Modal
                title="Como utilizar o relatório Contas a Pagar/Receber"
                className="modal"
                visible={isOpen}
                destroyOnClose
                onCancel={onClose}
                footer={null}
                width="50%"
                style={{ top: 10 }}
            >
                <Row>
                    <Col xs={24}>
                        <p>Para acessar o relatório de Contas a Pagar/Receber:  </p>

                        <div className="image-wrapper">
                            <img className="img_smaller" src={RelContasPagRec1} alt="Contas 1"/>
                        </div>

                        <div className="gray_bar"></div>

                        <div className="image-wrapper">
                            <img src={RelContasPagRec2} alt="Contas 2"/>
                        </div>                        

                        <h3>No relatório de Contas a Pagar/Receber nós temos:</h3>
                        <ol>
                            <li>Filtros para buscar os lançamentos financeiros mais facilmente.</li>
                            <li>Impressão dos lançamentos que estão na tabela.</li>
                            <li>Lançamentos de entrada que já foram liquidados.</li>
                            <li>Lançamentos de entrada que estão em aberto.</li>
                            <li>Lançamentos de saída que já foram liquidados.</li>
                            <li>Lançamentos de saída que estão em aberto.</li>
                            <li>Total da diferença entre as saídas e entradas dos lançamentos já liquidados.</li>
                            <li>Total da diferença entre as saídas e entradas dos lançamentos em aberto.</li>
                            <li>Tabela de lançamentos financeiros.</li>
                            <li>Botão auxiliar para abrir ou liquidar a parcela escolhida.</li>
                            <li>Paginação dos registros da tabela.</li>
                        </ol>

                        <div className="gray_bar"></div>

                        <h3>Como definir os lançamentos mostrados na tabela</h3>

                        <p>Para filtrar os lançamentos basta clicar no botão "Filtro" e selecionar quais os filtros que o gestor deseja aplicar.</p>

                        <div className="image-wrapper">
                            <img src={RelContasPagRec3} alt="Contas 3"/>
                        </div>   
                        <div className="image-wrapper">
                            <img src={RelContasPagRec4} alt="Contas 4"/>
                        </div>   

                        <div className="gray_bar"></div>           

                        <h3>Como gerenciar os pagamentos/Recebimentos</h3>

                        <p>
                            Depois de buscar os lançamentos o gestor terá a opção de abrir um lançamento já liquidado, ou liquidar um lançamento que esteja aberto. Para
                            poder abrir/liquidar um lançamento basta utilizar o botão auxiliar dentro da tabela e dentro de cada lançamento. 
                        </p>  
                        <div className="image-wrapper">
                            <img src={RelContasPagRec5} alt="Contas 5"/>
                        </div>                       
                        <p>
                            Ao clicar na opção, a tela aberta dependerá se a parcela do lançamento está liquidada ou está aberta. 
                        </p>    

                        <h3>Parcela Liquidada</h3>

                        <div className="image-wrapper">
                            <img src={RelContasPagRec6} alt="Contas 6"/>
                        </div>  

                        <p>
                            Quando a parcela ja está liquidada é possível abrir a parcela e cancelar a liquidação clicando no botão "Abrir Parcela".
                        </p>

                        <h3>Parcela Aberta</h3>
                        <div className="image-wrapper">
                            <img src={RelContasPagRec7} alt="Contas 7"/>
                        </div>   
                        <p>
                            Quando a parcela está aberta você pode liqudidar a parcela preenchendo as informações e clicando no botão de liquidar.
                        </p>                      
                        <p>
                            É possível também fazer a liquidação parcial da parcela clicando na opção "Pagamento Parcial", preenchendo as informações e clicando
                            no botão "Liquidar". 
                        </p>
                        <p>
                            Caso o gestor marque liquidação parcial, a segunda opção "Finalizar Parcela" irá ficar disponível. Essa opção serve para liquidar a parcela 
                            mesmo que o valor dos pagamentos parciais não complete o valor da parcela. Ficaria então a cargo do gestor gerenciar essa diferença no valor do pagamento.
                        </p>
                        <div className="image-wrapper">
                            <img src={RelContasPagRec8} alt="Contas 8"/>
                        </div>   

                        <p>
                            Quando a parcela foi paga parcialmente, ao abrir a parcela o gestor poderá ver as informações do pagamento parcial, e terá a opção de fazer outros
                            pagamentos parciais, ou finalizar a parcela, ou excluir os pagamentos parciais utilizando o botão da lixeira.
                        </p>    
                        <div className="image-wrapper">
                            <img src={RelContasPagRec9} alt="Contas 9"/>
                        </div>                                             

                    </Col>
                </Row>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/tutoriais/RelContasPagRec.js